<template>
  <div>

    <div class="hidden-md-up">
      <sidebar-current-issue></sidebar-current-issue>
      <sidebar-signup-button></sidebar-signup-button>
    </div>

    <full-issue v-if="topArticle.ids" v-bind:issue="topArticle"></full-issue>

    <div class="hidden-md-up">
      <sidebar-quick-links></sidebar-quick-links>
      <title-block title="Impact Factor / Index / Archive:">
        <div class="sidebar-block-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
      </title-block>
    </div>

    <sections-beyond-oncology></sections-beyond-oncology>

    <special-collection-archives></special-collection-archives>

    <title-block :title="`Top 5 ${siteName} Papers Rated by Altmetric Attention Score`" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="(issue, index) in issues" v-if="index<5" :key="issue.id" v-bind:issue="issue" :smallMode="index > 0 ? true : false"></condensed-issue>
      </div>
    </title-block>

    <title-block title="Top 100 Papers from the Editorial Board" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="(issue, index) in top100issues" :key="issue.id" v-bind:issue="issue" :smallMode="index > 0 ? true : false"></condensed-issue>
      </div>
    </title-block>

    <div class="hidden-md-up">
      <sidebar-sponsorship></sidebar-sponsorship>
    </div>

  </div>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import FullIssue from '@/components/shared/FullIssueComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import SectionsBeyondOncology from '@/components/home/SectionsBeyondOncologyComponent'
  import SpecialCollectionArchives from '@/components/home/SpecialCollectionArchivesComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import SidebarSignupButton from '@/components/main-layout/sidebar/SidebarSignUpButtonComponent'
  import SidebarCurrentIssue from '@/components/main-layout/sidebar/SidebarCurrentIssueComponent'
  import SidebarQuickLinks from '@/components/main-layout/sidebar/SidebarQuickLinksComponent'
  import SidebarSponsorship from '@/components/main-layout/sidebar/SidebarSponsorshipComponent'

  export default {
    components: {
      TitleBlock,
      FullIssue,
      CondensedIssue,
      SectionsBeyondOncology,
      SpecialCollectionArchives,
      SidebarSignupButton,
      SidebarCurrentIssue,
      SidebarQuickLinks,
      SidebarSponsorship
    },
    name: 'home',
    mixins: [ UtilityMixin ],
    data () {
      return {
        siteName: process.env.SITE_NAME,
        topArticle: {},
        issues: [],
        top100issues: []
      }
    },
    created () {
      this.$store.state.isEnhanced = false
      this.$http.get(this.$store.state.dataUrlArticle).then(function (response) {
        var topArticle = response.body
        // TODO: This part should be removed after services implementation - optimized_urls is missed in article.json example
        for (var i = 0; i < topArticle.files.figures.length; i++) {
          topArticle.files.figures[i].optimized_urls = {}
          topArticle.files.figures[i].optimized_urls['small'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/small/' + topArticle.files.figures[i].optimized_file
          topArticle.files.figures[i].optimized_urls['hero'] = 'https://s3-us-west-1.amazonaws.com/paperchase-aging/paper_figures_optimized/hero/' + topArticle.files.figures[i].optimized_file
        }
        this.topArticle = topArticle
      }, function () {
      })

      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.issues = response.body.articles
      }, function () {
      })

      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.top100issues = response.body.articles
      }, function () {
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// HomePage.vue?62a0d5c5